import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';
import logoImage from '../../../images/logo.png';

function Header() {
  return (
    <div>
      <div className="text-center">
        <Link to="/" >
          <img src={logoImage} width="70" height="70"></img>

        </Link>
        <span className="mx-3 text-dark text-center lh-1 fw-semibold fs-3">
          Pandit Ram Kedar Ram Kishore Tripathi Mahavidyalaya

          <span className="fs-3 "></span>
        </span>
      </div>
      <Navbar expand="lg md sm" className="py-0 w-100">
        <Container className="container mx-1">

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="bg-light"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto justify-content-end">
              <Nav.Link href="/" className="text-uppercase fw-semibold px-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  // width="12"
                  // height="12"
                  fill="currentColor"
                  className="bi bi-house-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293z" />
                  <path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293z" />
                </svg>
              </Nav.Link>
              <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="About"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/history">History</NavDropdown.Item>
                <NavDropdown.Item href="/mission&vision">
                  Mission & Vision
                </NavDropdown.Item>
                <NavDropdown.Item href="/objective">Objective</NavDropdown.Item>
                {/* <NavDropdown.Item href="/manager-msg">
                  Manager's Message
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="/principal-msg">
                  Principal's Message
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="/kulgeet">
                  College Kulgeet
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="/gallery">
                  Gallery
                </NavDropdown.Item> */}
              </NavDropdown>

              <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="Courses"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/course_bed">B.Ed.</NavDropdown.Item>
                <NavDropdown.Item href="/course_deled">D.El.Ed.</NavDropdown.Item>
                <NavDropdown.Item href="/undergraduate">
                  Undergraduate
                </NavDropdown.Item>
                <NavDropdown.Item href="postgraduate">
                  Postgraduate
                </NavDropdown.Item>
              </NavDropdown>

              {/* student  */}
              <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="Student"
                id="basic-nav-dropdown"
              >

                <NavDropdown.Item href="/student_data">Student Data</NavDropdown.Item>
                <NavDropdown.Item href="/attendence">Biometric Attendance
                </NavDropdown.Item>
                <NavDropdown.Item href="/timetable">Time Table/Academic Calendar </NavDropdown.Item>
                <NavDropdown.Item href="/complaints">Online Grievances</NavDropdown.Item>
                <NavDropdown.Item href="/feedback"> Feedback</NavDropdown.Item>
                <NavDropdown.Item href="/samarthPortal"> Samarth Portal Verification</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="Admission"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/admission">Admission</NavDropdown.Item>
                <NavDropdown.Item href="/admission-procedure">
                  Admission Procedure
                </NavDropdown.Item>
                <NavDropdown.Item href="/college-rules-and-regulations">
                  Rules & Regulations of College
                </NavDropdown.Item>
                <NavDropdown.Item href="/library-rules-and-regulations">
                  {" "}
                  Rules & Regulations of Library
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="Facilities"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/smartClass">
                  Smart Classroom
                </NavDropdown.Item>
                <NavDropdown.Item href="/lab">
                  {" "}
                  Lab & Laboratory{" "}
                </NavDropdown.Item>
                <NavDropdown.Item href="/library"> Library </NavDropdown.Item>
                <NavDropdown.Item href="/sports"> Sports </NavDropdown.Item>
                <NavDropdown.Item href="/nss"> NSS </NavDropdown.Item>
                <NavDropdown.Item href="/computer-center">
                  {" "}
                  Computer Center{" "}
                </NavDropdown.Item>
                <NavDropdown.Item href="/college-campus">
                  {" "}
                  College Campus{" "}
                </NavDropdown.Item>
                <NavDropdown.Item href="/swyamPrabha">
                  {" "}
                  Swyam Prabha{" "}
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link
                href="/ncteOrder"
                className="text-uppercase fw-semibold px-1"
              >
                NCTE.&nbsp;Order
              </Nav.Link>
              <Nav.Link
                href="/annualReport"
                className="text-uppercase fw-semibold px-1"
              >
                Annual Report
              </Nav.Link>

              {/* <Nav.Link href="/faculty" className="text-uppercase fw-semibold px-1">
                Faculty
              </Nav.Link> */}
              <Nav.Link
                href="/disciplinary"
                className="text-uppercase fw-semibold px-1"
              >
                Disciplinary Cell
              </Nav.Link>

              <Nav.Link
                href="/faculty"
                className="text-uppercase fw-semibold px-1"
              >
                Faculty
              </Nav.Link>

               <Nav.Link
                href="/career"
                className="text-uppercase fw-semibold px-1"
              >
                Career
              </Nav.Link>

              {/* <NavDropdown
                className="text-uppercase fw-semibold px-0"
                title="Result"
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item href="/talent-search-result-2024">
                  Talent Search Exam <br />
                  2024 Result
                </NavDropdown.Item>
              </NavDropdown> */}
              {/* <Nav.Link href='/courses' className='text-uppercase fw-semibold px-1'>Report</Nav.Link> */}


            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;